import React from 'react';
import { motion } from 'framer-motion';
interface KnowledgeMapProps {
  showNew?: boolean;
  className?: string;
  labels?: boolean;
}
const nodes = [{
  id: 'screen',
  label: 'Evening screen use',
  x: 70,
  y: 50
}, {
  id: 'sleep',
  label: 'Sleep fragmentation',
  x: 135,
  y: 112,
  key: true
}, {
  id: 'memory',
  label: 'Working memory',
  x: 300,
  y: 92,
  key: true
}, {
  id: 'adol',
  label: 'Adolescence',
  x: 60,
  y: 196
}, {
  id: 'attn',
  label: 'Sustained attention',
  x: 215,
  y: 200
}, {
  id: 'acad',
  label: 'Academic outcomes',
  x: 340,
  y: 196
}, {
  id: 'load',
  label: 'Cognitive load',
  x: 250,
  y: 30
}];
const edges: [string, string][] = [['screen', 'sleep'], ['sleep', 'adol'], ['sleep', 'attn'], ['attn', 'memory'], ['memory', 'acad'], ['adol', 'attn'], ['load', 'memory'], ['attn', 'acad']];
function pos(id: string) {
  const n = nodes.find(node => node.id === id);
  return n ? {
    x: n.x,
    y: n.y
  } : {
    x: 0,
    y: 0
  };
}
export function KnowledgeMap({
  showNew = false,
  className,
  labels = true
}: KnowledgeMapProps) {
  const a = pos('sleep');
  const b = pos('memory');
  return <svg viewBox="0 0 400 240" className={className} role="img" aria-label="Sample knowledge map of related concepts" data-id="element-281" data-mp="1lfcxratdk3bp">
      {edges.map(([from, to]) => {
      const p = pos(from);
      const q = pos(to);
      return <line key={`${from}-${to}`} x1={p.x} y1={p.y} x2={q.x} y2={q.y} stroke="#0A1020" strokeOpacity="0.12" strokeWidth="1.2" data-id="element-282" data-mp="1ceyd8do8is99" />;
    })}
      {showNew ? <>
          <line x1={a.x} y1={a.y} x2={b.x} y2={b.y} stroke="#2B5BE8" strokeOpacity="0.18" strokeWidth="8" strokeLinecap="round" data-id="element-283" data-mp="245ufkkco5eia" />
          <motion.line x1={a.x} y1={a.y} x2={b.x} y2={b.y} stroke="#2B5BE8" strokeWidth="2" strokeLinecap="round" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-284" data-mp="1qdo95pzbilw1" />
        </> : <line x1={a.x} y1={a.y} x2={b.x} y2={b.y} stroke="#0A1020" strokeOpacity="0.18" strokeWidth="1.2" strokeDasharray="3 4" data-id="element-285" data-mp="2xoitsfojcq2s" />}
      {nodes.map(n => <g key={n.id} data-id="element-286" data-mp="2nr4ckdusfx9f">
          {n.key && showNew ? <circle cx={n.x} cy={n.y} r="11" fill="#2B5BE8" fillOpacity="0.12" data-id="element-287" data-mp="2nq348h55pove" /> : null}
          <circle cx={n.x} cy={n.y} r={n.key ? 6 : 4.5} fill={n.key ? showNew ? '#2B5BE8' : '#0A1020' : '#fff'} stroke={n.key ? 'none' : '#0A1020'} strokeOpacity="0.35" strokeWidth="1.2" data-id="element-288" data-mp="2ir9oei2edls2" />
          {labels ? <text x={n.x} y={n.y + (n.y < 60 ? -12 : 20)} textAnchor="middle" fontSize="10.5" fontFamily="Inter, sans-serif" fontWeight={n.key ? 600 : 400} fill={n.key ? '#0A1020' : '#677286'} data-id="element-289" data-mp="251oc1qj3s4t0">
              {n.label}
            </text> : null}
        </g>)}
    </svg>;
}